import React from 'react';
import { Shirt, Layers, Palette, Package, Truck, Award } from 'lucide-react';
const services = [{
  icon: Shirt,
  title: 'Custom Apparel',
  description: 'Premium t-shirts, hoodies, and activewear printed with soft-hand inks that feel great to wear.'
}, {
  icon: Layers,
  title: 'Bulk Production',
  description: 'High-volume capabilities for events, corporate uniforms, and merchandise programs.'
}, {
  icon: Palette,
  title: 'Design Services',
  description: 'Our in-house art department helps optimize your artwork for the best possible print results.'
}, {
  icon: Package,
  title: 'Fulfillment',
  description: 'We can fold, bag, tag, and ship your orders directly to your customers or employees.'
}, {
  icon: Award,
  title: 'Embroidery',
  description: 'Professional embroidery for hats, polos, and jackets to give a high-end textured look.'
}, {
  icon: Truck,
  title: 'Rush Orders',
  description: 'Tight deadline? We offer expedited production services to get your gear when you need it.'
}];
export function Services() {
  return <section id="services" className="py-24 bg-stone-50" data-id="element-178">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-180">
          <h2 className="text-red-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-181">
            Our Expertise
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-182">
            Everything You Need to Look Professional
          </h3>
          <p className="text-lg text-gray-600" data-id="element-183">
            From single color prints to complex simulated process, we handle it
            all with precision and care.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-184">
          {services.map((service, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md hover:border-blue-100 transition-all duration-300 group" data-id="element-185">
              <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-900 transition-colors duration-300" data-id="element-186">
                <service.icon className="h-6 w-6 text-blue-900 group-hover:text-white transition-colors duration-300" data-id="element-187" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-188">
                {service.title}
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-189">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}